import { render, staticRenderFns } from "./createShipment.vue?vue&type=template&id=03064ec5&"
import script from "./createShipment.vue?vue&type=script&lang=js&"
export * from "./createShipment.vue?vue&type=script&lang=js&"
import style0 from "./createShipment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports